







import { Component, Vue, Prop } from 'vue-property-decorator'; // デコレータ
import router from '@/router';
import axios from 'axios';
// import { uketsukeManagementModule } from './store/modules/UketsukeManger';
import { supervisingModule } from '@/store/modules/OperationSupervising';
import { ScreenName } from '@/CommonUtils/fixed/ScreenName';
import { Constants } from '@/CommonUtils/fixed/Constants';

@Component
export default class CEFoundationApp extends Vue {
  private isOrderUser() {
    return supervisingModule.IS_ORDER_USER;
  }
  private getUserInfo() {
    return supervisingModule.GET_USER_INFO.szkNm + '　' + supervisingModule.GET_USER_INFO.username;
  }
  private toCeFoundation() {
    router.push({name: 'ceFoundationMenu'});
  }
  private toMenu() {
    router.push({name: ScreenName.MENU});
  }

  private logout() {
    if (supervisingModule.IS_ORDER_USER) {
      // ユーザが発注者の時
      axios.post(Constants.KANRI_URL + '/logout')
           .then((response) => {
            // 成功
            router.push({name: ScreenName.LOGOUT});
          });
    } else {
      // ユーザが受注者の時
      axios.post(Constants.UKETSUKE_URL + '/logout')
           .then((response) => {
            // 成功
            router.push({name: ScreenName.LOGOUT});
          });
    }
  }
}
